import {
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IMultiLineBehaviorSpecifiable, instanceOfIMultiLineBehaviorSpecifiable,
  ITooltipBehaviorSpecifiable, instanceOfITooltipBehaviorSpecifiable,
  INaturalTextBehaviorSpecifiable, instanceOfINaturalTextBehaviorSpecifiable,
  IEmptyAlertBehaviorSpecifiable, instanceOfIEmptyAlertBehaviorSpecifiable,
  ILengthAlertBehaviorSpecifiable, instanceOfILengthAlertBehaviorSpecifiable,
  IFreeInputBehaviorSpecifiable, instanceOfIFreeInputBehaviorSpecifiable,
  IInputRuleBehaviorSpecifiable, instanceOfIInputRuleBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { ITextDrawableObject, instanceOfITextDrawableObject } from "./ITextDrawableObject";
import { ElementTypes } from "./ElementTypes";

export interface ICalculatableObject extends
ITextDrawableObject,
IPrintBehaviorSpecifiable,
IEditBehaviorSpecifiable, 
IMultiLineBehaviorSpecifiable,
ITooltipBehaviorSpecifiable,
INaturalTextBehaviorSpecifiable,
IEmptyAlertBehaviorSpecifiable,
ILengthAlertBehaviorSpecifiable,
IFreeInputBehaviorSpecifiable,
IInputRuleBehaviorSpecifiable {
}

export function instanceOfICalculatableObject<T extends ICalculatableObject>(instance: any, type: ElementTypes): instance is ICalculatableObject {
  return instance
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIMultiLineBehaviorSpecifiable(instance)
      && instanceOfITooltipBehaviorSpecifiable(instance)
      && instanceOfINaturalTextBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertBehaviorSpecifiable(instance)
      && instanceOfILengthAlertBehaviorSpecifiable(instance)
      && instanceOfIFreeInputBehaviorSpecifiable(instance)
      && instanceOfIInputRuleBehaviorSpecifiable(instance)
      && instanceOfITextDrawableObject<T>(instance, type);
}
